import React from 'react';
import WaveDivider from './WaveDivider.jsx';

const Education = () => {
  const educationItems = [
    {
      title: 'Fachinformatikerin Anwendungsentwicklung',
      institution: 'synyx GmbH & Co. KG',
      period: '2019 - 2022',
      description: 'Ausbildung zur Fachinformatikerin mit Schwerpunkt Anwendungsentwicklung',
      icon: 'fas fa-graduation-cap',
      highlight: true
    },
    {
      title: 'Medizinische Technologin für Laboratoriumsanalytik',
      institution: 'Labor PD Dr. Volkmann und Kollegen GbR',
      period: '2016 - 2019',
      description: 'Ausbildung im medizinischen Laborbereich',
      icon: 'fas fa-microscope'
    },
    {
      title: 'Studium Angewandte Biologie',
      institution: 'Karlsruher Institut für Technologie (KIT)',
      period: '2015 - 2016',
      description: 'Studium der Angewandten Biologie',
      icon: 'fas fa-university'
    },
    {
      title: 'Abitur',
      institution: 'Hebel-Gymnasium Pforzheim',
      period: '2006 - 2015',
      description: 'Allgemeine Hochschulreife',
      icon: 'fas fa-school'
    }
  ];

  return (
    <section id="education" className="section education">
      <h2>Ausbildung & Bildung</h2>
      <div className="education-timeline">
        {educationItems.map((item, index) => (
          <div key={index} className={`education-item ${item.highlight ? 'highlight' : ''}`}>
            <div className="education-icon">
              <i className={item.icon}></i>
            </div>
            <div className="education-content">
              <h3>{item.title}</h3>
              <h4>{item.institution}</h4>
              <p className="education-period">{item.period}</p>
              <p className="education-description">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
      
    </section>
  );
};

export default Education; 